import './style.css'
import * as THREE from 'three'
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'

let camera, scene, renderer, gui, aspect, container;
let width = 0, height = 0;
let onPointerDownPointerX, onPointerDownPointerY, onPointerDownLon, onPointerDownLat
let lon = 0, lat = 0;

const params = {
    rotationD: 0,
    rotationR: 0,
    envMap: false,
    plus: function () {
        params.rotationD += 45;
        gui.updateDisplay();
    },
    minus: function () {
        params.rotationD -= 45;
        gui.updateDisplay();
    },
    clear: function () {
        params.rotationD = 0;
        gui.updateDisplay();
    },
    zoom: 1,
    resetZoom: function () {
        params.zoom = camera.zoom = 1
        lon = lat = 0;
        camera.updateProjectionMatrix();
        gui.updateDisplay();

    },
    download: download
};

const sides = {
    'front': THREE.FrontSide,
    'back': THREE.BackSide,
    'double': THREE.DoubleSide

};

let cameraOrtho, cameraPerspective;
let controlsOrtho, controlsPerspective;

let mesh, materialStandard, materialDepthBasic, materialDepthRGBA, materialNormal;

init();
animate();
initGui();

// Init gui
function initGui() {

    gui = new dat.GUI()

    gui.add(params, 'rotationD', -180, 180, 0.5).name('Degrees').onChange(function () {
        params.rotationR = this.getValue() * (Math.PI / 180)
        gui.updateDisplay();
    })//.listen(); //the keyboard input doesn't work with listen... updateDisplay fix

    gui.add(params, 'rotationR', -Math.PI, Math.PI, 0.000001).name('Radians').onChange(function () {
        params.rotationD = this.getValue() / (Math.PI / 180)
        gui.updateDisplay();
    })//.listen();


    gui.add(params, 'plus').name('Rotate +45°');
    gui.add(params, 'minus').name('Rotate -45°');
    gui.add(params, 'clear').name('Reset Rotate');


    gui.add(params, 'zoom', 0.1, 10, 0.01).name('Zoom').onChange(function () {
        camera.zoom = this.getValue();
        camera.updateProjectionMatrix();
        gui.updateDisplay();
    });

    gui.add(params, 'resetZoom').name('Reset Zoom');
    
    
    gui.add(params, 'envMap').name('Env Map').onChange(function () {
        if (this.getValue()) {
            mesh.material = materialStandard;
        } else {
            mesh.material = materialNormal;
        }
    });
    
    gui.add(params, 'download').name('Download Map');
    //gui.add( params, 'zoom',  1,10, 0.01  ).name('Camera Z (Zoom)');

}

function init() {

    container = document.createElement('div');
    document.body.appendChild(container);



    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true, premultipliedAlpha: true });
    renderer.domElement.id = 'mainCanvas';
    //renderer.setClearColor( 0x8080FF, 1 );
    renderer.setClearColor( 0x000000, 0 );
    renderer.setPixelRatio(window.devicePixelRatio);
    width = window.innerWidth;
    height = window.innerHeight;
    renderer.setSize(width, height);
    container.appendChild(renderer.domElement);



    //
    aspect = window.innerWidth / window.innerHeight;
    scene = new THREE.Scene();



    cameraOrtho = new THREE.OrthographicCamera(- height * aspect, height * aspect, height, - height, 1000, 2500);

    cameraOrtho.position.z = 1500;
    scene.add(cameraOrtho);

    camera = cameraOrtho;

    /* controlsOrtho = new OrbitControls( cameraOrtho, renderer.domElement );
    controlsOrtho.minZoom = 0.1;
    controlsOrtho.maxZoom = 10.5;
    controlsOrtho.enablePan = true;
    //controlsOrtho.enableRotate = false;
    controlsOrtho.rotateSpeed = 0;
    //controlsOrtho.enableDamping = true; */

    // lights

    /* const ambientLight = new THREE.AmbientLight( 0xffffff, 0.1 );
    scene.add( ambientLight );

    const pointLight = new THREE.PointLight( 0xff0000, 0.5 );
    pointLight.position.z = 2500;
    scene.add( pointLight );

    const pointLight2 = new THREE.PointLight( 0xff6666, 1 );
    camera.add( pointLight2 );

    const pointLight3 = new THREE.PointLight( 0x0000ff, 0.5 );
    pointLight3.position.x = - 1000;
    pointLight3.position.z = 1000;
    scene.add( pointLight3 ); */

    // textures

    const textureLoader = new THREE.TextureLoader();
    const normalMap = textureLoader.load("./normal.png");
    const envMap = textureLoader.load("./venice_sunset_1k.jpg");
    envMap.mapping = THREE.EquirectangularReflectionMapping;
    envMap.encoding = THREE.LinearEncoding;
    //normalMap.rotation = Math.PI/2;
    //normalMap.center = new THREE.Vector2(0.5, 0.5); // center of texture.


    // material


    materialStandard = new THREE.MeshStandardMaterial({
        color: 0xffffff,

        metalness: 0.9,
        roughness: 0.1,

        normalMap: normalMap,
        normalScale: new THREE.Vector2(1, 1),
        envMap: envMap,

        side: THREE.DoubleSide
    });

    materialNormal = new THREE.MeshNormalMaterial({

        normalMap: normalMap,
        normalScale: new THREE.Vector2(1, 1),

        //flatShading: true,

        side: THREE.DoubleSide
    });

    //

    //const geometry =  new THREE.BoxGeometry(20,20,20);
    //const geometry = new THREE.PlaneBufferGeometry(24,24);
    const geometry = new THREE.PlaneGeometry(600, 600);


    mesh = new THREE.Mesh(geometry, materialNormal);
    mesh.scale.multiplyScalar(2); //unit to pixels
    //mesh.scale.x = -25;
    //mesh.rotation.x =  -Math.PI/4;
    scene.add(mesh);



    //
    //Drag'n'drop / Paste
    initDragAndDrop();
    initPaste();
    //
    window.addEventListener('resize', onWindowResize);
    //Controls
    container.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('wheel', onDocumentMouseWheel);

}

function onWindowResize() {

    width = window.innerWidth;
    height = window.innerHeight;
    aspect = window.innerWidth / window.innerHeight;

    camera.aspect = aspect;

    camera.left = - height * aspect;
    camera.right = height * aspect;
    camera.top = height;
    camera.bottom = - height;
    camera.updateProjectionMatrix();

    renderer.setSize(width, height);

}

//

function animate() {

    requestAnimationFrame(animate);

    render();

}

function render() {


    mesh.rotation.z = -params.rotationD * (Math.PI / 180);
    camera.position.x = -lon * (2 / camera.zoom);
    camera.position.y = lat * (2 / camera.zoom);
    //controlsOrtho.update(); // must update both controls for damping to complete
    //controlsOrtho.zoom = params.zoom;
    //console.log(camera.zoom);

    camera.updateProjectionMatrix();

    //camera.lookAt( scene.position );

    renderer.render(scene, camera);

}



//Custom Pan/Zoom Controls

function onPointerDown(event) {

    //event.preventDefault();

    onPointerDownPointerX = event.clientX;
    onPointerDownPointerY = event.clientY;

    onPointerDownLon = lon;
    onPointerDownLat = lat;

    container.addEventListener('pointermove', onPointerMove, false);
    container.addEventListener('pointerup', onPointerUp, false);


}

function onPointerMove(event) {

    lon = (event.clientX - onPointerDownPointerX) + onPointerDownLon;
    lat = (event.clientY - onPointerDownPointerY) + onPointerDownLat;


}

function onPointerUp() {

    container.removeEventListener('pointermove', onPointerMove);
    container.removeEventListener('pointerup', onPointerUp);

}

function onDocumentMouseWheel(event) {

    const zoom = camera.zoom - event.deltaY * 0.0005;

    params.zoom = camera.zoom = THREE.MathUtils.clamp(zoom, 0.1, 10);

    camera.updateProjectionMatrix();
    gui.updateDisplay();

}


//Normal Map File Handling

function updateNormalMap(texture) {

    if (mesh.material.normalMap) {

        mesh.material.normalMap.dispose();

    }

    materialStandard.normalMap = materialNormal.normalMap = texture;

    texture.needsUpdate = true;

    mesh.material.needsUpdate = true; // because the encoding can change

    render();

}

//Fix plane proportions to image ratio
function updatePlaneSize(w, h) {
    //mesh.scale.x = w/h * mesh.scale.y;
    //mesh.geometry.width = w;
    //mesh.geometry.height = h;
    //mesh.scale.set( w, h, 1 );

    const geometry = new THREE.PlaneGeometry(w, h);
    mesh.geometry = geometry;

    //mesh.updateMatrix();

}

function handleJPG(event) { // PNG, too

    function imgCallback(event) {

        const texture = new THREE.Texture(event.target);

        texture.encoding = THREE.LinearEncoding;

        updatePlaneSize(texture.image.width, texture.image.height)
        updateNormalMap(texture);

    }

    const img = new Image();

    img.onload = imgCallback;

    img.src = event.target.result;

}

function initDragAndDrop() {

    document.addEventListener('dragover', function (event) {

        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';

    });

    document.addEventListener('drop', function (event) {

        event.preventDefault();

        loadFile(event.dataTransfer.files[0]);

    });

}

function initPaste(){
    // window.addEventListener('paste', ... or
    document.addEventListener('paste',function(event){
        var items = (event.clipboardData || event.originalEvent.clipboardData).items;
        console.log(JSON.stringify(items)); // will give you the mime types
        for (let index in items) {
          var item = items[index];
          if (item.kind === 'file') {
            var blob = item.getAsFile();
            loadFile(blob);
          }
        }
    });
}


function loadFile(file) {

    const filename = file.name;
    //const extension = filename.split( '.' ).pop().toLowerCase();

    // 'jpg', 'png'

    const reader = new FileReader();

    reader.addEventListener('load', function (event) {

        handleJPG(event);

    });

    reader.readAsDataURL(file);



}

function download(){
    var link = document.createElement('a');
    link.download = 'normal_map_rotated.png';
    link.href = document.getElementById('mainCanvas').toDataURL();
    link.click();
}